import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

export const AuthorNamesContainer = styled.div`
  margin: 0;

  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 21px;
`;

export const CommaSeparator = styled.span`
  padding-inline-end: 3px;
`;

export const AndSeparator = styled.span`
  padding-block: 0;
  padding-inline: 3px;

  font-weight: 400;
`;

export const AuthorLocation = styled.span`
  padding-inline-start: 3px;

  color: #4585ff;
`;
